/* eslint-disable class-methods-use-this */
import DOMReady from '../utils/DOMReady'

// Include css for webpack (for development only)
const css = require('../../css/blocks/values-slider.scss') // eslint-disable-line no-unused-vars

class ValuesSlider {
  constructor(el) {
    this.container = el
    this.root = document.documentElement
    this.arrows = this.container.querySelectorAll('[data-values-direction]')
    this.names = this.container.querySelectorAll('[data-values-name]')
    this.descriptions = this.container.querySelectorAll('[data-values-description]')
    this.images = this.container.querySelectorAll('[data-values-image]')
    this.arrowPrev = this.container.querySelector('[data-values-direction="prev"]')
    this.arrowNext = this.container.querySelector('[data-values-direction="next"]')
    this.currentIndex = 0

    this.init()
  }

  changeValuesActiveOption(valueOption) {
    valueOption.forEach((option, i) => {
      if (i === this.currentIndex) {
        option.classList.toggle('active', true)
      } else {
        option.classList.toggle('active', false)
      }
    })
  }

  slideValuesImagesWrapper() {
    const valuesImagesContainerWidth = this.container.querySelector(
      '.values-slider__slides-container',
    ).offsetWidth
    const valuesImagesWrapperWidth = this.container.querySelector(
      '.values-slider__slides-wrapper',
    ).offsetWidth
    const valuesMoveStep =
      this.images[2].getBoundingClientRect().x - this.images[1].getBoundingClientRect().x

    const max = valuesImagesContainerWidth - valuesImagesWrapperWidth
    let moveBy = valuesMoveStep * this.currentIndex * -1
    if (moveBy < max) moveBy = max
    this.root.style.setProperty('--valuesSlidesWrapperTranslateDistance', `${moveBy}px`)
  }

  handleChange() {
    if (this.currentIndex > 0) {
      this.arrowPrev.classList.toggle('inactive', false)
    } else {
      this.arrowPrev.classList.toggle('inactive', true)
    }

    if (this.currentIndex === this.images.length - 1) {
      this.arrowNext.classList.toggle('inactive', true)
    } else {
      this.arrowNext.classList.toggle('inactive', false)
    }

    this.changeValuesActiveOption(this.names)
    this.changeValuesActiveOption(this.descriptions)
    this.changeValuesActiveOption(this.images)
    this.slideValuesImagesWrapper()
  }

  init() {
    this.arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        const { valuesDirection } = arrow.dataset
        if (!valuesDirection) return
        this.currentIndex =
          valuesDirection === 'next' ? this.currentIndex + 1 : this.currentIndex - 1
        this.handleChange()
      })
    })
    this.images.forEach(image => {
      image.addEventListener('click', () => {
        const { valuesImage } = image.dataset
        this.currentIndex = Number(valuesImage)
        this.handleChange()
      })
    })
    window.addEventListener('resize', () => {
      this.slideValuesImagesWrapper()
    })
  }
}

DOMReady(() => {
  const wrapperEl = document.querySelectorAll('.values-slider')
  Array.from(wrapperEl).forEach(el => {
    // eslint-disable-next-line no-new
    new ValuesSlider(el)
  })
})
